import React from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function FeatureCard({ icon, title, description, pillar, pillars, slug }) {
  const pillarColors = {
    operations: { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-200' },
    network: { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-200' },
    care: { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-200' }
  };

  // Handle both single pillar and multi-pillar features
  const featurePillars = pillars || [pillar];
  const primaryPillar = featurePillars[0];
  const colors = pillarColors[primaryPillar] || pillarColors.operations;

  return (
    <Card className="h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
      <CardContent className="p-8 flex flex-col h-full">
        <div className="flex items-center justify-center mb-6 text-blue-600">
          {icon}
        </div>

        <Typography variant="h5" className="mb-3 font-bold text-gray-900 text-center">
          {title}
        </Typography>
        
        <div className="flex flex-wrap justify-center gap-2 mb-4">
          {featurePillars.map(p => (
            <div key={p} className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${pillarColors[p]?.bg || colors.bg} ${pillarColors[p]?.text || colors.text}`}>
              {p}
            </div>
          ))}
        </div>

        <Typography variant="body2" className="mb-6 text-gray-600 leading-relaxed text-center flex-grow">
          {description}
        </Typography>

        <Button
          component={Link}
          to={`/features/${slug}`}
          variant="text"
          className="text-blue-600 hover:text-blue-800 font-semibold self-center mt-auto"
        >
          Learn More →
        </Button>
      </CardContent>
    </Card>
  );
}

export default FeatureCard;
